import { Row, Col } from 'antd'

import _map from 'lodash/map'

import Title from 'components/Title'
import CardVoucher from 'components/Card/CardVoucher'
import Link from 'components/Link'

import Styled from './styled'

export default function Vouchers({ vouchers = [] }) {
  return (
    <Styled>
      <div className="container">
        <div className="article-content">
          <div className="title-block">
            <Title level={1} className="title">
              โปรโมชั่นสุดพิเศษ
            </Title>
          </div>

          <Row
            gutter={[
              { xs: 0, sm: 0, md: 16, lg: 34 },
              { xs: 14, sm: 14, md: 16, lg: 34 },
            ]}
          >
            {_map(vouchers, (item, index) => {
              const slug = item?.code
              const link = `/voucher/${slug}`

              return (
                <Col span={24} md={12} lg={8} key={index}>
                  <Link href={link}>
                    <CardVoucher
                      title={item?.title}
                      detail={item?.shortDescription}
                      image={item?.thumbnailImage?.[0]?.url}
                      // validStartDate={item?.validStartDate}
                      // validEndDate={item?.validEndDate}
                    />
                  </Link>
                </Col>
              )
            })}
          </Row>
        </div>
      </div>
    </Styled>
  )
}
